module.exports = __webpack_public_path__ + "assets/18ee10a0403311b1e438241919e55753.mp3";